import { postAppleWallet, postGoogleWallet } from '@/api/wallet.js';
import AddToAppleWallet from '@/components/AddToAppleWallet/AddToAppleWallet.jsx';
import useDeviceDetect from '@/hooks/useDeviceDetect.js';
import { saveAs } from 'file-saver';
import SaveToGooglePayButton from '@google-pay/save-button-react';
import React, { useEffect, useState } from 'react';
import { SnackBar, GoogleButtonSkeleton } from '@desquared/wave-components-library';
import { useTranslations } from 'next-intl';
import styles from './DigitalCards.module.css';

export default function DigitalCards({ user, showLoyaltyCardButton }) {
  const t = useTranslations('user_loyalty');

  const [walletError, setWalletError] = useState('');
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const { isAndroid, isIos } = useDeviceDetect();
  const [googleJWT, setGoogleJWT] = useState({});
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  useEffect(() => {
    if (!showLoyaltyCardButton) return;
    setWalletError('');
    setSnackBarOpen(false);
    async function addToGoogleWallet() {
      try {
        const { googleJwt } = await postGoogleWallet(user?.loyaltyCards[0].cardId);
        setGoogleJWT(googleJwt);
        setIsGoogleLoading(false);
      } catch (error) {
        setWalletError(error.response?.data?.userMessage || t('error_mobile_pass'));
        setSnackBarOpen(true);
      }
    }
    if (isAndroid) {
      setIsGoogleLoading(true);
      addToGoogleWallet();
    }
  }, [isAndroid, showLoyaltyCardButton]);

  async function addToAppleWallet() {
    try {
      const { data, type } = await postAppleWallet(user?.loyaltyCards[0].cardId);

      const passData = new Blob([data], { type });
      saveAs(passData, `${process.env.tenant}.pkpass`);
    } catch (error) {
      setWalletError(error.response?.data?.userMessage || t('error_mobile_pass'));
      setSnackBarOpen(true);
    }
  }

  if (!showLoyaltyCardButton) return null;

  return (
    <>
      <div className={styles.buttons}>
        {isAndroid && !walletError && googleJWT && (
          <>
            {isGoogleLoading && <GoogleButtonSkeleton />}
            {!isGoogleLoading && (
              <div className={styles.addToGPayContainer}>
                <SaveToGooglePayButton jwt={googleJWT} size="matchparent" height="standard" />
              </div>
            )}
          </>
        )}
        {isIos && !walletError && (
          <div className={styles.walletImageContainer}>
            <AddToAppleWallet addToAppleWallet={addToAppleWallet} />
          </div>
        )}
      </div>

      <div style={{ width: '100%' }}>
        <SnackBar
          open={snackBarOpen}
          setOpen={() => setSnackBarOpen(false)}
          text={walletError}
          hasCloseOption={true}
          position={'center'}
        />
      </div>
    </>
  );
}
